__turbopack_context__.v({
  "footer": "FooterCompact-module__QebMmq__footer",
  "link": "FooterCompact-module__QebMmq__link",
});
